// Formatos compartidos de la inteligencia de inventario.
export const numero = (v, d = 0) =>
  v === null || v === undefined ? '—' : Number(v).toLocaleString('es-MX', { maximumFractionDigits: d });

export function fecha(iso) {
  if (!iso) return '—';
  try { return new Date(iso.length === 10 ? `${iso}T12:00:00` : iso).toLocaleDateString('es-MX', { day: 'numeric', month: 'long' }); } catch { return iso; }
}

// El color dice la verdad: verde solo con confianza alta, amarillo si el
// modelo mismo dice que anduvo flojo en el holdout, gris sin datos.
export function tonoConfianza(confianza) {
  if (confianza === null || confianza === undefined) return 'gris';
  if (confianza >= 0.65) return 'verde';
  if (confianza >= 0.4) return 'amarillo';
  return 'rojo';
}

export const CLASE_TONO = {
  verde: 'bg-green-50 text-green-800 border-green-200',
  amarillo: 'bg-amber-50 text-amber-800 border-amber-200',
  rojo: 'bg-red-50 text-red-800 border-red-200',
  gris: 'bg-gray-50 text-gray-600 border-gray-200',
};

export function textoConfianza(confianza) {
  const t = tonoConfianza(confianza);
  if (t === 'gris') return 'Sin medir';
  const pct = Math.round(Number(confianza) * 100);
  return t === 'verde' ? `Confianza ${pct} %` : t === 'amarillo' ? `Confianza baja (${pct} %)` : `Confianza muy baja (${pct} %)`;
}
